import { Reference, ReferenceData } from '@/store/plan/ReferenceData/ReferenceData';
import { AxiosResponse } from 'axios';
import { AxiosInstance } from 'axios';
import { CopyStatuses, ICopyStatuses } from '@/store/plan/CopyStatuses/CopyStatuses';
import { YearDetail } from '@/store/plan/Detail/YearDetail';
import { PlansCommonResponse } from '@/repository/manager/plans/types/PlansCommonResponse';
import { IDetail } from '@/store/plan/Detail/IDeteil';
import { YearsRepository } from '@/model/repository/manager/childcare-document/plan/YearsRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): YearsRepository => ({
    async getStatuses(year: string, group_id: string, use_db_replica: boolean): Promise<CopyStatuses> {
      return new Promise<CopyStatuses>((resolve, reject) => {
        Repository.get(`${resource}/statuses/decade/${year}`, { params: { group_id, use_db_replica } })
          .then((res: AxiosResponse<PlansCommonResponse<ICopyStatuses>>) => {
            resolve(new CopyStatuses(res.data.data));
          })
          .catch((error) => {
            const status = error.response ? error.response.status : null;
            reject({ error, status });
          });
      });
    },

    async getContents(year: string, payload: { group_id: string }): Promise<ReferenceData> {
      return new Promise<ReferenceData>((resolve, reject) => {
        Repository.get(`${resource}/contents/${year}`, { params: payload })
          .then((res: AxiosResponse<PlansCommonResponse<Reference>>) => {
            const referenceData = new ReferenceData(res.data.data.content, res.data.data.display_date);
            resolve(referenceData);
          })
          .catch((error) => {
            const status = error.response ? error.response.status : null;
            reject({ error, status });
          });
      });
    },

    async getDetail(fiscalYear: string, payload: { group_id: string; use_db_replica: boolean }): Promise<YearDetail> {
      return new Promise<YearDetail>((resolve, reject) => {
        Repository.get(`${resource}/fiscal-year/${fiscalYear}`, { params: payload })
          .then((response: AxiosResponse<PlansCommonResponse<IDetail>>) => {
            const res = response.data.data;
            resolve(
              new YearDetail(
                res.id,
                res.kind,
                res.title,
                res.content,
                res.display_date,
                res.permission_id,
                res.file_url,
                res.update_datetime,
                res.topic_relations
              )
            );
          })
          .catch((error) => {
            const status = error.response ? error.response.status : null;
            reject({ error, status });
          });
      });
    },
  });
